// extracted by mini-css-extract-plugin
module.exports = {"loginBox":"Login_loginBox__3jQxq","loginInputWrapper":"Login_loginInputWrapper__3v4-X","loginInput":"Login_loginInput__3XBEy"};